<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF ALLIED HEALTH SCIENCES</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Physiotherapy</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Under Graduate</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">Bachelor of Science in Physiotherapy</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="row">

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Science in Physiotherapy</b>
                    – The Bachelor of Science in Physiotherapy (B.Sc. Physiotherapy) offered by ARNI School of Allied
                    Health Sciences is a three-year undergraduate program designed to develop skilled physiotherapists
                    who can diagnose, manage, and prevent movement-related disorders. This program integrates
                    theoretical knowledge with practical training to help students gain expertise in rehabilitation,
                    therapeutic exercises, and pain management.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b></p>
                <ul>
                    <li> English Communication</li>
                    <li> Human Anatomy</li>
                    <li> Human Physiology</li>
                    <li> Electrotherapy I</li>
                    <li> Biochemistry</li>
                    <li> Basics of Nursing</li>
                </ul>

            </div>


            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b></p>
                <ul>
                    <li> Physiotherapy</li>
                    <li> Orientation to Physiotherapy</li>
                    <li> Biomechanics</li>
                    <li> Exercise Therapy</li>
                    <li> Pathology and Microbiology</li>
                    <li> Elective I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b></p>
                <ul>
                    <li> First Aid & CPR</li>
                    <li> Constitution of India</li>
                    <li> Biomechanics & Kinesiology</li>
                    <li> Pharmacology</li>
                    <li> Medical</li>
                    <li> Microbiology</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b></p>
                <ul>
                    <li> Exercise Therapy II</li>
                    <li> Electrotherapy II</li>
                    <li> General Medicine & Psychiatry</li>
                    <li> Orthopedics</li>
                    <li> Neurology</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 5</b></p>
                <ul>
                    <li> Physical and Functional Diagnostic Skills</li>
                    <li> Research Methodology and Biostatistics</li>
                    <li> Obstetrics and Gynecology</li>
                    <li> General Surgery</li>
                    <li> Physiotherapy in Neurological Conditions</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 6</b></p>
                <ul>
                    <li> Orthopedics and Sports Physiotherapy</li>
                    <li> Allied Therapies</li>
                    <li> Supervised Rotatory Clinical Training</li>
                    <li> Physiotherapy in Cardiorespiratory and General Conditions</li>
                    <li> Practical/Seminar</li>
                </ul>
            </div>

        </div>

    </div>
</section>
